export default __webpack_public_path__ + "static/media/baby-4.a8cf60a9.svg";